document.documentElement.classList.remove('is-loading');

let resizeTimer;

window.addEventListener('resize', () => {
    document.documentElement.classList.add('is-resizing');
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        document.documentElement.classList.remove('is-resizing');
    }, 400);
}, { passive: true });